import home from './home';
import events from './events';
import information from './information';
import artists from './artists';
import view404 from './view-404';

export default [
	home, events, information, artists, view404
];